// extracted by mini-css-extract-plugin
export var aiStarIcon = "_ba-4";
export var closeButton = "_ba-6";
export var dismissButton = "_ba-3";
export var editImageWithAiContainer = "_ba-8";
export var imageUploadWrapper = "_ba-7";
export var misspelledWord = "_ba-5";
export var spellCheckContainer = "_ba-2";
export var spin = "_ba-1";
export var spinning = "_ba-0";